import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-admin`;
const PRESETS = [1, 3, 5, 10];

export const WeeklyLimitCell = ({ client, token }) => {
  const [limit, setLimit] = useState(client.weekly_check_limit ?? null);
  const [draft, setDraft] = useState(limit ?? '');
  const [open, setOpen] = useState(false);
  if (client.is_super_admin) return <span className="text-xs text-slate-400" data-testid={`admin-weekly-limit-${client.client_id}`}>No limit</span>;
  const save = async (v) => {
    try {
      await axios.put(`${API}/clients/${client.client_id}/weekly-limit`, { limit: v }, { headers: { Authorization: `Bearer ${token}` } });
      setLimit(v); setDraft(v ?? ''); setOpen(false);
      toast.success(`${client.email}: ${v == null ? 'no weekly limit' : `${v} checks per week`}`);
    } catch (e) { toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || 'Could not save'); }
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={`admin-weekly-limit-${client.client_id}`} className="px-2 py-1 rounded bg-slate-700 text-slate-200 text-xs hover:bg-slate-600">
          {limit == null ? 'No limit' : `${limit} / week`}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-60 bg-slate-800 border-slate-600 text-white" data-testid={`admin-weekly-limit-pop-${client.client_id}`}>
        <p className="text-xs text-slate-400 mb-2">Checks this subscriber can mint per 7 days</p>
        <div className="flex flex-wrap gap-1 mb-3">
          {PRESETS.map(n => <button key={n} onClick={() => save(n)} data-testid={`weekly-limit-preset-${n}`} className="px-2 py-1 rounded bg-slate-700 text-xs hover:bg-emerald-600">{n}</button>)}
          <button onClick={() => save(null)} data-testid="weekly-limit-preset-none" className="px-2 py-1 rounded bg-slate-700 text-xs hover:bg-emerald-600">No limit</button>
        </div>
        <div className="flex gap-2">
          <input type="number" min="0" step="1" value={draft} onChange={(e) => setDraft(e.target.value)} data-testid="weekly-limit-input"
            className="w-20 bg-slate-900 border border-slate-600 rounded px-2 py-1 text-sm" />
          <button onClick={() => save(Math.floor(Number(draft)))} disabled={draft === '' || Number(draft) < 0} data-testid="weekly-limit-save" className="px-3 py-1 rounded bg-emerald-600 text-xs disabled:opacity-40">Save</button>
        </div>
      </PopoverContent>
    </Popover>
  );
};
